/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const changeUnexpectedPaymentOutcomePostRequestSchema = z.object({
  reference: z.string(),
  value: z.string(),
});
